import React, { JSX } from 'react';

const Shimmer = ({ className }: { className: string }): JSX.Element => (
  <div className={`loading ${className}`} />
);

export const ClinicalTrialsResultSkeleton = (): JSX.Element => (
  <article
    className="clinical-trial-result clinical-trial-result--skeleton"
    aria-hidden="true"
  >
    <div className="clinical-trial-result__badges">
      <Shimmer className="clinical-trials-skeleton__badge" />
      <Shimmer className="clinical-trials-skeleton__badge clinical-trials-skeleton__badge--sm" />
      <Shimmer className="clinical-trials-skeleton__badge clinical-trials-skeleton__badge--md" />
    </div>
    <Shimmer className="clinical-trials-skeleton__title" />
    <div className="clinical-trial-result__meta">
      <Shimmer className="clinical-trials-skeleton__line" />
      <Shimmer className="clinical-trials-skeleton__line clinical-trials-skeleton__line--sm" />
    </div>
    <div className="clinical-trial-result__actions">
      <Shimmer className="clinical-trials-skeleton__btn" />
      <Shimmer className="clinical-trials-skeleton__btn" />
    </div>
  </article>
);

export const ClinicalTrialsResultsSkeleton = (): JSX.Element => (
  <div
    className="clinical-trials-results-skeleton"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <span className="screen-recording-only">Loading clinical trials</span>
    <ClinicalTrialsResultSkeleton />
    <ClinicalTrialsResultSkeleton />
    <ClinicalTrialsResultSkeleton />
  </div>
);

export const ClinicalTrialsDetailsSkeleton = (): JSX.Element => (
  <div
    className="clinical-trials-details-skeleton"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <span className="screen-recording-only">Loading clinical trial</span>
    <div className="clinical-trials-details__header">
      <div className="clinical-trial-result__badges">
        <Shimmer className="clinical-trials-skeleton__badge" />
        <Shimmer className="clinical-trials-skeleton__badge clinical-trials-skeleton__badge--sm" />
        <Shimmer className="clinical-trials-skeleton__badge clinical-trials-skeleton__badge--md" />
      </div>
      <Shimmer className="clinical-trials-skeleton__title clinical-trials-skeleton__title--lg" />
      <Shimmer className="clinical-trials-skeleton__line" />
      <Shimmer className="clinical-trials-skeleton__line clinical-trials-skeleton__line--sm" />
      <div className="clinical-trials-details__actions">
        <Shimmer className="clinical-trials-skeleton__btn" />
        <Shimmer className="clinical-trials-skeleton__btn" />
      </div>
    </div>
    <div className="clinical-trials-details__grid">
      <Shimmer className="clinical-trials-skeleton__block" />
      <Shimmer className="clinical-trials-skeleton__block clinical-trials-skeleton__block--sm" />
    </div>
  </div>
);
